import React, { useContext, useState } from 'react';
import { PrimeReactContext } from 'primereact/api';
import { InputSwitch } from "primereact/inputswitch";

const ThemeSwitcher = () => {
  const [checked, setChecked] = useState(false);
  const context = useContext(PrimeReactContext);
 

  if (!context) {
    throw new Error("PrimeReactContext is not available. Make sure you have wrapped your application with PrimeReactContext.Provider.");
}

const { changeTheme } = context;

const toggleTheme = () => {
    const currentTheme = checked ? 'lara-dark-blue' : 'lara-light-blue';
    const newTheme = checked ? 'lara-light-blue' : 'lara-dark-blue';
    const linkElementId = 'theme-link';

    changeTheme(currentTheme, newTheme, linkElementId, () => {
        console.log(`Theme changed from ${currentTheme} to ${newTheme}`);
        setChecked(!checked);
    });
};

  return (
     <InputSwitch checked={checked} onChange={toggleTheme} />
  );
};

export default ThemeSwitcher;
